// extracted by mini-css-extract-plugin
module.exports = {"content":"cd01fbf7b5--content--tHuub","builder":"cd01fbf7b5--builder--xsvmw","name":"cd01fbf7b5--name--RP8jG","footer":"cd01fbf7b5--footer--ur2Oi"};